import { useMutation } from '@apollo/client'
import quoteStatusQuery from '@Builder/QuoteDetailPage/FilesTab/ImQuoteTabSections/ManufacturabilityFeedbackTab/DfmCategorySection/quoteStatusQuery'
import {
    notifyAdminMutation,
    notifyAdminOnOdpMutation,
} from '@Builder/QuoteDetailPage/FilesTab/ImQuoteTabSections/ManufacturabilityFeedbackTab/NotifyFictivAlert/mutations'
import { useDispatch } from 'react-redux'

import logger from '~/lib/logger'
import { getCoreQuoteDetailsData } from '~/redux-modules/query-refactor/actions'

const useImDfmOperations = () => {
    const dispatch = useDispatch()
    const [notifyAdmin] = useMutation(notifyAdminMutation)
    const [notifyAdminOnOdp] = useMutation(notifyAdminOnOdpMutation)

    return {
        notifyFictivAdmin: async (quoteId?: string | null, userId?: string) => {
            try {
                await notifyAdmin({
                    variables: {
                        quoteId,
                        userId,
                    },
                    refetchQueries: [
                        {
                            query: quoteStatusQuery,
                            variables: { id: quoteId },
                        },
                    ],
                })
                dispatch(getCoreQuoteDetailsData(quoteId as string))
            } catch (err) {
                logger.exception(err, {
                    extra: {
                        info: 'notifyAdmin mutation on quotes page failed',
                        quoteId,
                        userId,
                    },
                })
            }
        },
        notifyFictivAdminOnOdp: async (
            userId?: string,
            orderId?: string | null,
        ) => {
            try {
                await notifyAdminOnOdp({
                    variables: {
                        userId,
                        orderId,
                    },
                })
            } catch (err) {
                logger.exception(err, {
                    extra: {
                        info: 'notifyAdmin mutation on ODP failed',
                        orderId,
                        userId,
                    },
                })
            }
        },
    }
}

export default useImDfmOperations
